import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType, BiDataHook } from '@wix/da-bi/pkg/constants';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { dateDiff } from '../../../Timestamp/functions';
import { useVerification } from '../../../VerificationPopup/withVerification';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import CommentIcon from '@wix/da-ds/pkg/Icons/Comment';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { CommentContext } from '../../CommentContext';
import FooterRowLayout from '../../layouts/FooterRowLayout';
import LikeButton from './LikeButton';
import AwardBadgeButton from './AwardBadgeButton';
import CommentBadges from './CommentBadges';
import ReplyButton from './ReplyButton';
import s from './CommentFooter.scss';
/** All of our comment interaction buttons in a nice row. Includes liking, replying, badge awarding, and editing. */
var CommentFooter = function (_a) {
    var _b = _a.canPostComment, canPostComment = _b === void 0 ? true : _b, disableEdit = _a.disableEdit, className = _a.className, isCommentReduxReady = _a.isCommentReduxReady;
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var _c = useContext(CommentContext), comment = _c.comment, setEditingState = _c.setEditingState, isCommentVisible = _c.isCommentVisible;
    var restrictToVerified = useVerification().restrictToVerified;
    var t = useTranslation().t;
    var onClickEdit = restrictToVerified('comment', function () {
        return setEditingState('editing');
    });
    // Limited to 1 day since post
    var canEdit = !disableEdit &&
        comment.isAuthor &&
        dateDiff(new Date().toISOString(), comment.posted, 'days') === 0;
    if (!isCommentVisible) {
        return null;
    }
    return (React.createElement(FooterRowLayout, { className: className, "data-hook": BiDataHook.COMMENT_FOOTER, blocks: [
            (canPostComment || !isLoggedIn) && canEdit && (React.createElement(PlainButtonOrLink, { key: "edit-button", className: s['action'], onClick: onClickEdit, "data-hook": BiDataHook.COMMENT_EDIT_BUTTON, biData: {
                    evid: BiEventType.COMMENT_EDIT_CLICK,
                    commentid: comment.commentId,
                    typeid: comment.typeId,
                    itemid: comment.itemId,
                }, disabled: !isCommentReduxReady }, t('comment.action.edit'))),
            (canPostComment || !isLoggedIn) && (React.createElement(ReplyButton, { key: "reply-button", className: s['action'], disabled: !isCommentReduxReady },
                React.createElement("span", { className: s['reply-with-icon'] },
                    React.createElement(CommentIcon, { className: s['reply-icon'], size: IconSize.SMALLER }),
                    t('comment.action.reply')))),
            React.createElement("div", { className: s['action'], key: "like-button" },
                React.createElement(LikeButton, { disabled: !isCommentReduxReady })),
            !comment.isAuthor && (React.createElement("div", { className: s['action'], key: "award-badge-button" },
                React.createElement(AwardBadgeButton, { disabled: !isCommentReduxReady }))),
            React.createElement(CommentBadges, { key: "badges" }),
        ] }));
};
CommentFooter.displayName = 'CommentFooter';
export default CommentFooter;
//# sourceMappingURL=CommentFooter.js.map